import { datadogRum } from '@datadog/browser-rum';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import PageError from '../PageError';

type OwnProps = {
  error?: Error | string;
  resetErrorBoundary?: () => void;
};

export default function PrequalPageError({
  error,
  resetErrorBoundary
}: OwnProps) {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);

  const tryReset = async () => {
    datadogRum.addAction(DATADOG_EVENTS.PREQUALIFIED.PAGE_ERROR_CLICKED_RESET);
    setIsLoading(true);
    await new Promise(resolve => setTimeout(resolve, 700));
    resetErrorBoundary?.();
    setIsLoading(false);
  };

  const handleHomeNavigation = () => {
    datadogRum.addAction(DATADOG_EVENTS.PREQUALIFIED.PAGE_ERROR_CLICKED_HOME);
    router.push('/');

    return;
  };

  useEffect(() => {
    datadogRum.addError(DATADOG_EVENTS.PREQUALIFIED.PAGE_ERROR, {
      error
    });
  }, [error]);

  return (
    <PageError
      isLoading={isLoading}
      onGoHome={handleHomeNavigation}
      onTryAgain={tryReset}
    />
  );
}
